<template>
  <div class="app-wrapper tw-w-screen">
    <header class="tw-text-black tw-text-2xl">
      <nav class="tw-flex tw-flex-end tw-items-center tw-justify-between tw-px-4 lg:tw-px-12 tw-py-4 lg:tw-py-8">
        <div class="tw-w-40 tw-grow-0 tw-inline-block lg:tw-hidden">
          <button 
          :class="['tw-flex', {'opened':mobileNavOpen}]" 
          @click="toggleMobileNav"
          :data-expanded="mobileNavOpen" 
          aria-label="Main Menu" 
          :aria-expanded="mobileNavOpen" 
          >
            <svg width="40" height="40" viewBox="0 0 100 100">
              <path class="line line1" d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
              <path class="line line2" d="M 20,50 H 80" />
              <path class="line line3" d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
            </svg>
          </button>
        </div>
        <RouterLink to="/menu">
          <NavLogo
            class="tw-mx-auto lg:tw-ml-0 lg:tw-mr-12"/>
        </RouterLink>

        <div class="lg:tw-ml-auto tw-w-40 lg:tw-w-auto tw-grow-0 tw-flex lg:tw-inline-block tw-justify-end">
          <RouterLink to="/menu" class="tw-hidden lg:tw-inline-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium">
            Menu
          </RouterLink>
          <a href="/catering-menu" class="tw-hidden lg:tw-inline-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium" >Back to MyPiada</a>
          <a href="/faq-catering" target="_blank" class="tw-hidden lg:tw-inline-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium" >Catering FAQ</a>
          <template v-if="userStore.user">
            <a href="/order/user" class="tw-hidden lg:tw-inline-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium">Hello, {{userStore.user.first_name}}!</a>
          </template>
          <template v-else>
            <a href="/order/users/login?n=online-catering" class="tw-hidden lg:tw-inline-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium">Sign In</a>
          </template>
          
          <button
            ref="bagDropdownButton"
            id="bagDropdownButton"
            class="lg:tw-ml-8 tw-bg-orange-medium hover:tw-bg-black tw-transition-all tw-text-white tw-rounded-full tw-px-4 lg:tw-px-10 tw-py-2 lg:tw-py-4"
            @click="toggleDropdownBag" 
            data-dropdown-toggle="bag-dropdown">
            <div class="tw-hidden lg:tw-flex tw-items-center">
              <div :class="['tw-inline-block tw-w-12 tw-text-center', {'animate-jiggle': animateCart}]">
                <template v-if="reloadingCart">
                  <span class="tw-text-5xl fa fa-spinner tw-animate-spin tw--mt-1" v-if="!showBag"></span>
                </template>
                <template v-else>
                  <span class="tw-text-5xl bag-icon icon icon-piada-bag" v-if="!showBag"></span>
                  <span class="tw-inline-block tw-text-5xl icon" v-if="showBag">&times;</span>
                </template>
              </div>
              <div class="tw-inline-block tw-ml-4 tw-font-bold tw-uppercase" >
                My Order
              </div>
              <span class="tw-opacity-50 tw-rounded-full tw-ml-4 tw-px-4 tw-py-2 tw-bg-black tw-text-lg tw-font-black tw-transition-all tw-inline-block"
                v-if="basketStore.basket && basketStore.itemCount">
                {{ basketStore.itemCount }} 
              </span>
            </div>

            <div class="tw-flex lg:tw-hidden tw-font-black tw-text-sm">My Order</div>
          </button>
        </div>
      </nav>
    </header>

    <div class="tw-relative">
      <transition name="mobile-nav-fade">
        <div v-if="mobileNavOpen" class="tw-py-12 tw-bg-black tw-text-white tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-z-10 tw-shadow-lg">
          <RouterLink to="/menu" class="tw-w-full tw-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium tw-py-4" @click="toggleMobileNav">
            Menu
          </RouterLink>
          <a href="/catering-menu" class="tw-w-full tw-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium tw-py-4">Back to MyPiada</a>
          <a href="/faq-catering" target="_blank" class="tw-w-full tw-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium tw-py-4" >Catering FAQ</a>
          <RouterLink :to="{ name: 'wizard-step', params: { step:  2}}" class="tw-w-full tw-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium tw-py-4" @click="toggleMobileNav">Edit Order Details</RouterLink>
          <template v-if="userStore.user">
            <a href="/order/user" class="tw-w-full tw-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium tw-py-4">Hello, {{userStore.user.first_name}}!</a>
          </template>
          <template v-else>
            <a href="/order/users/login?n=online-catering" class="tw-w-full tw-block tw-uppercase tw-text-2xl tw-font-bold tw-px-4 hover:tw-text-orange-medium tw-py-4">Sign In</a>
          </template>
        </div>
      </transition>

      <Dropdown
        ref="bagComponent"
        :showBag="showBag" />

      <div class="flash-wrapper tw-fixed tw-z-100 tw-bottom-0 lg:tw-bottom-12 tw-z-1000 tw-right-0 lg:tw-right-8 inset-y-0 inset-x-0 tw-z-50 tw-mx-auto tw-block tw-w-full lg:tw-inline-block lg:tw-w-1/3">
        <TransitionGroup name="list">
          <FlashMessage
            v-for="message in flashMessageStore.messages"
            v-bind:key="message.id"
            @dismissAlert="dismissAlert"
            :message="message" />
        </TransitionGroup>
      </div>

      <div v-if="!appInitializing">
        <RouterView :key="$route.fullPath" />
      </div>
    </div>

    <TwModal
      v-show="cateringDisabledModalOpen"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeCateringDisabledModal"
      >
      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">Online catering unavailable at {{ cateringDisabledModalLocation ? cateringDisabledModalLocation.name : 'this location' }}</h2>
        </div>

        <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
         {{ cateringDisabledMessage }}
        </p>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-inline-block"
            @emit-click="redirectWizard" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Start New Order'"/>
        </div>
      </template>
    </TwModal> 

    <TwModal
      v-show="continueCateringModalOpen"
      :hasHeader="false"
      :modalSize="'large'"
      @emitClose="handleContinueCateringDecline"
    >
      <template #body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">Continue your catering order?</h2>
        </div>

        <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
          You already have catering items in your order. Do you want to pick up where you left off?
        </p>
      </template>

      <template #footer>
        <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4 tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-rounded-full tw-inline-block"
            @emit-click="handleContinueCateringAccept"
            :isLoading="false"
            :isDisabled="false"
            :buttonText="'Continue Order'"
          />
          <TwButton
            cssClass="tw-bg-white tw-border-2 tw-border-black tw-text-black hover:tw-bg-black hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-rounded-full tw-inline-block"
            @emit-click="handleContinueCateringDecline"
            :isLoading="false"
            :isDisabled="false"
            :buttonText="'No, Stay Here'"
          />
        </div>
      </template>
    </TwModal>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, watch } from "vue";
  import { RouterLink, RouterView, useRouter } from 'vue-router';
  import { storeToRefs } from 'pinia';
  // import { onClickOutside } from '@vueuse/core';

  // Data
  import { useUserStore } from "./stores/user";
  import { useBasketStore } from "./stores/basket";
  import { useCateringOrderStore } from "./stores/catering_order";
  import { useLocationsStore } from "./stores/locations";
  import { useFlashMessageStore } from "./stores/flashMessages";
  import type Location from './classes/Location';
  import type FlashMessageType from './types/FlashMessage';
  import type CateringOrder from './types/CateringOrder';
  import type Basket from './classes/Basket';
  import type User from './classes/User'
  import { DateTime } from 'luxon';

  import FlashMessage from './components/FlashMessage.vue';
  import Dropdown from './views/bag/_Dropdown.vue';
  import NavLogo from './components/NavLogo.vue';
  import TwModal from './components/TwModal.vue';
  import TwButton from './components/TwButton.vue';

  const userStore = useUserStore();
  const basketStore = useBasketStore();
  const cateringOrderStore = useCateringOrderStore();
  const flashMessageStore = useFlashMessageStore();
  const locationsStore = useLocationsStore();

  const { itemCount } = storeToRefs(basketStore);
  const { messages } = storeToRefs(flashMessageStore);

  const router = useRouter();

  const animateCart = ref(false);
  const reloadingCart = ref(false);
  const prevItemCount = ref(0);
  const showBag = ref(false);
  const bagComponent = ref(null);
  const bagDropdownButton = ref(null);
  const mobileNavOpen = ref(false);
  const debugMode = ref(true);
  const appInitializing = ref(true);
  const basketLookupCount = ref(0);
  const cateringDisabledModalOpen = ref(false);
  const cateringDisabledModalLocation = ref(null as (Location | null));
  const cateringDisabledMessage = ref(undefined as (undefined | string));
  const continueCateringModalOpen = ref(false);
  const hasPromptedCateringResume = ref(false);

  onMounted(() => {
    initializeWithParams();

    userStore.fetchUser().then(() => {
      getLocations();
    }).catch((error: Error) => {
      // Oh well
      getLocations();
    })

    if (document.getElementById('catering_assistance_level')) {
      const catering_assistance_level = document.getElementById('catering_assistance_level')! as HTMLInputElement;
      if (catering_assistance_level.value) {
        cateringOrderStore.setAssistanceLevel(parseFloat(catering_assistance_level.value));
      }
    }
  })

  const initializeWithParams = (() => {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    
    if (urlParams.has('update_product')){
      const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "success",
        text: "Product has been updated.",
        headline: "",
        delay: 5000, // ms
        icon: "",
        cssClass: "",
      } as FlashMessageType;
      flashMessageStore.addMessage(message);

      urlParams.delete('update_product');
      
      // Clean up the params
      if (history.replaceState) {
        let searchString = urlParams.toString().length > 0 ? '?' + urlParams.toString() : '';
        let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname +  searchString + window.location.hash;
        history.replaceState(null, '', newUrl);
      }
    }

    if (urlParams.has('cid')){
      localStorage.setItem('cateringOrder', urlParams.get('cid')!)
      urlParams.delete('cid');
    }

    if (localStorage.getItem('PiadaOneReload')) {
      const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "danger",
        text: localStorage.getItem('PiadaOneReload'),
        headline: "",
        delay: 0, // ms
        icon: "",
        cssClass: "",
      } as FlashMessageType;
      flashMessageStore.addMessage(message);

      localStorage.removeItem('PiadaOneReload');
    }
  })

  watch(itemCount, () => {
    const updatedVal = basketStore.itemCount
    if (updatedVal != prevItemCount.value) {
      animateCart.value = true;

      setTimeout(function() {
        animateCart.value = false;
        prevItemCount.value = updatedVal
      }, 400);
    }
  })

  router.afterEach((to, from) => { 
    closeBag();
  });

  const detectCateringProducts = (basket?: Basket | null): boolean => {
    if (!basket) {
      return false;
    }

    try {
      if (typeof basket.hasCateringProducts === 'function') {
        return basket.hasCateringProducts();
      }
    } catch (_error) {
      // Ignore and fall back to a simple metadata check
    }

    const products = (basket as unknown as { products?: Array<{ isCatering?: () => boolean }> }).products ?? [];

    return products.some((product) => {
      if (!product || typeof product.isCatering !== 'function') {
        return false;
      }

      try {
        return product.isCatering();
      } catch (_error) {
        return false;
      }
    });
  };

  const maybePromptForExistingCateringOrder = (basket?: Basket | null) => {
    if (hasPromptedCateringResume.value || continueCateringModalOpen.value) {
      return;
    }

    if (!detectCateringProducts(basket)) {
      return;
    }

    const currentRouteName = router.currentRoute.value?.name;

    if (currentRouteName && currentRouteName.toString() === 'menu') {
      return;
    }

    continueCateringModalOpen.value = true;
  };

  const handleContinueCateringDecline = () => {
    hasPromptedCateringResume.value = true;
    continueCateringModalOpen.value = false;
  };

  const handleContinueCateringAccept = () => {
    hasPromptedCateringResume.value = true;
    continueCateringModalOpen.value = false;
    router.push('/menu');
  };

  function getBasket(order?: CateringOrder): Promise<any> {
    return new Promise((resolve, reject) => {
      if (basketLookupCount.value < 4) {
        basketLookupCount.value += 1
        let catering_basket_id = null as (string | null);
        if (document.getElementById('catering_basket_id')) {
          catering_basket_id = (document.getElementById('catering_basket_id')! as HTMLInputElement).value;
          basketStore.sessionBasketId = catering_basket_id;
        }

        if (localStorage.getItem('mypiadaBasketId')) {
          basketStore.fetchBasketWithPromise(localStorage.getItem('mypiadaBasketId')!).then((basket: Basket) => {
            resolve(basket);
          }).catch((error: Error) => {
            // delete our local storage ID and try again
            localStorage.removeItem('mypiadaBasketId');
            // Send it without an order since the catering order basket id look up failed
            getBasket(undefined).then((basket: Basket) => {
              resolve(basket);
            });
          });
        } else if (catering_basket_id) {
          basketStore.fetchBasketWithPromise(catering_basket_id).then((basket: Basket) => {
            localStorage.setItem('mypiadaBasketId', catering_basket_id! as string);
            resolve(basket);
          }).catch((error: Error) => {
            resolve(null);
          });
        } else {
          resolve(null);
        }
      } else {
        // Make attempts tried
        resolve(null);
      }
    })
  }

  // On load we're going to fetch locations and set the user's location if its saved in local
  function getLocations() {
    locationsStore.fetchLocations().then(() => {
      const cateringOrderId = localStorage.getItem('cateringOrder');

      if (cateringOrderId) {
        // If the user has a catering order
        cateringOrderStore.fetchCateringOrder(parseFloat(cateringOrderId)).then((order: CateringOrder) => {
          let requireUserUpdate = false;
          let updateAssistanceLevel = false;
          let catering_assistance_level = undefined as (undefined | number);
          // Check if the user came back to the app with a different assistance level for us to orverride the save one
          if (document.getElementById('catering_assistance_level')) {
            let catering_assistance_level_field = document.getElementById('catering_assistance_level')! as HTMLInputElement;
            catering_assistance_level = parseFloat(catering_assistance_level_field.value);
            updateAssistanceLevel = (!isNaN(catering_assistance_level) && catering_assistance_level != order.assistance_level)
          }

          if (updateAssistanceLevel) {
            order.assistance_level = catering_assistance_level!;
          }
          
          // See if we can set the Piada user
          if (order.user_id == null && userStore.user != null) {
            requireUserUpdate = true;
          }

          getBasket(order).then((basket: Basket) => {
            // We got a basket back
            let currentLocation = null as (string | null);
            if (basket) {
              maybePromptForExistingCateringOrder(basket);
              currentLocation = basket.vendorid.toString();

              if (basketStore.editOrderCutoffTime && basketStore.editOrderCutoffTime != "") {
                let cutoff = DateTime.fromISO(basketStore.editOrderCutoffTime);
                if (cutoff < DateTime.now()) {

                  // Clear the edit since it can't be completed
                  basketStore.cancelEditOrder().then(() => {
                    const message = {
                      id: Math.round(Date.now() / 1000),
                      messageType: "danger",
                      text: "The order you were editing can no longer be edited.",
                      headline: "",
                      delay: 0, // ms
                      icon: "",
                      cssClass: "",
                    } as FlashMessageType;
                    flashMessageStore.addMessage(message);

                    router.push('/wizard')
                  });
                }
              } else {
                if (basket.id != order.basket_id) {
                  order.basket_id = basket.id;
                  order.store = basket.vendorid;
                  cateringOrderStore.updateCateringOrder(parseFloat(cateringOrderId), order);
                  updateAssistanceLevel = false; // Just saved it
                  requireUserUpdate = false;
                }
              }
            } else {
              currentLocation = localStorage.getItem("mypiadaCurrentLocation");
              if (order.basket_id) {
                order.basket_id = "";
                if (localStorage.getItem("mypiadaCurrentLocation")) {
                  order.store = parseFloat(localStorage.getItem("mypiadaCurrentLocation")!);
                }
                cateringOrderStore.updateCateringOrder(parseFloat(cateringOrderId), order);
                updateAssistanceLevel = false; // Just saved it
                requireUserUpdate = false;
              }
            }

            if (currentLocation && locationsStore.locations) {
              let locationObj = locationsStore.locations.find((loc: Location) => {
                return loc.id == parseFloat(currentLocation!)
              })

              if (locationObj) {
                userStore.setUserLocation(locationObj);

                if (locationObj.catering_disabled) {
                  cateringDisabledModalOpen.value = true;
                  cateringDisabledModalLocation.value = locationObj;
                  cateringDisabledMessage.value = locationObj.catering_disabled_message;
                }
              } else {
                // Clear the local storage because something terrible probably happened
                localStorage.removeItem("mypiadaCurrentLocation");
              }

              if (router.currentRoute.value.name == 'home') {
                router.push('/menu')
              }
            } else {
              // No location to set
              router.push('/wizard')
            }

            if (updateAssistanceLevel || requireUserUpdate) {
              // Fallback to setting here if nothing else set it
              cateringOrderStore.updateCateringOrder(parseFloat(cateringOrderId), order);
              updateAssistanceLevel = false; // Just saved it
              requireUserUpdate = false;
            }

            cancelLoader();
          }).catch((error: Error) => {
            cancelLoader();
          })
        }).catch((error: Error) => {
          localStorage.removeItem('cateringOrder');
          const message = {
            id: Math.round(Date.now() / 1000),
            messageType: "danger",
            text: "Your catering order details could not be found.",
            headline: "Error",
            delay: 0, // ms
            icon: "",
            cssClass: "",
          } as FlashMessageType;
          flashMessageStore.addMessage(message);
          cancelLoader();
        })
      } else {
        getBasket(undefined).then((basket: Basket) => {
          // We got a basket back
          let currentLocation = null as (string | null);
          if (basket) {
            maybePromptForExistingCateringOrder(basket);
            currentLocation = basket.vendorid.toString();
          } else {
            currentLocation = localStorage.getItem("mypiadaCurrentLocation");
          }

          if (currentLocation && locationsStore.locations) {

            let locationObj = locationsStore.locations.find((loc: Location) => {
              return loc.id == parseFloat(currentLocation!)
            })

            if (locationObj) {
              userStore.setUserLocation(locationObj);
            } else {
              // Clear the local storage because something terrible probably happened
              localStorage.removeItem("mypiadaCurrentLocation");
            }
          }

          router.push('/wizard');
          cancelLoader();
        }).catch((error: Error) => {
          cancelLoader();
        })
      }
    }).catch((error: Error) => {
      cancelLoader();
      errorFlash(error.message, '')
    })
  }

  const cancelLoader = (() => {
    appInitializing.value = false;
    // Remove the loader
    if (document.getElementById('app_loader')) {
      document.getElementById('app_loader')!.remove();
    }
  })

  // onClickOutside(bagComponent, (event) => {
  //   const target: HTMLElement = event.target as HTMLElement;

  //   if (target == bagDropdownButton.value || target.closest('#bagDropdownButton')) {
  //     // Let the normal click handler take it
  //   } else if (showBag.value == true) {
  //     closeBag()
  //   }
  // })

  const toggleMobileNav = (() => {
    mobileNavOpen.value = !mobileNavOpen.value
    if (mobileNavOpen.value) {
      showBag.value = false
    }

  })

  const closeBag = (() => {
    showBag.value = false
  })

  const toggleDropdownBag = (() => {
    const routeName = router.currentRoute.value.name;
    let isCheckout = false;
    if (routeName) {
      isCheckout = (['review-bag', 'checkout', 'order-confirmation'].indexOf(routeName!.toString()) > -1)
    }

    let localBasketId = localStorage.getItem('mypiadaBasketId');

    if (isCheckout) {
      if (localBasketId) {
        reloadingCart.value = true;
        basketStore.fetchBasketWithPromise(localBasketId).then(() => {
          reloadingCart.value = false;
          window.scrollTo({top: 160, left:0, behavior: "smooth"});
        })
      } else {
        location.reload();
      }
    } else {
      showBag.value = !showBag.value
      if (showBag.value) {
        mobileNavOpen.value = false
      }
    }
  })

  const dismissAlert = ((id: number) => {
    flashMessageStore.dismissMessage(id);
  })


  const errorFlash = (title: string, text: string) => {
    const message = {
      id: Math.round(Date.now() / 1000),
      messageType: "danger",
      text: text,
      headline: title,
      delay: 0, // ms
      icon: "",
      cssClass: "",
    } as FlashMessageType;
    flashMessageStore.addMessage(message);
  }

  const closeCateringDisabledModal = () => {
    cateringDisabledModalOpen.value = false;
    window.setTimeout(function() {
      cateringDisabledMessage.value = '';
      cateringDisabledModalLocation.value = null;
    }, 500);
  }

  const redirectWizard = () => {
    closeCateringDisabledModal();
    router.push('/wizard')
  }

</script>

<style>
  body {
    padding-top:  0px !important;
  }

  .app-wrapper {
    min-height: 80vh;
    background-color: #F3F2F2;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.5s ease;
  }
  .list-enter-from,
  .list-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

  .animate-jiggle {
    animation: thejiggle 400ms ease-in-out both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

  @keyframes thejiggle {
    0% { transform: translate(0px, 0px) scale(1.0) rotate(0deg); }
    25% { transform: translate(0px, 1px) scale(1.03) rotate(-12deg); }
    50% { transform: translate(0px, 0px) scale(0.95) rotate(0deg); }
    75% { transform: translate(1px, 0px) scale(1.01) rotate(11deg); }
  }

  .line {
    fill: none;
    stroke: #333;
    stroke-width: 6;
    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
      stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  .line1 {
    stroke-dasharray: 60 207;
    stroke-width: 6;
  }
  .line2 {
    stroke-dasharray: 60 60;
    stroke-width: 6;
  }
  .line3 {
    stroke-dasharray: 60 207;
    stroke-width: 6;
  }
  .opened .line1 {
    stroke-dasharray: 90 207;
    stroke-dashoffset: -134;
    stroke-width: 6;
  }
  .opened .line2 {
    stroke-dasharray: 1 60;
    stroke-dashoffset: -30;
    stroke-width: 6;
  }
  .opened .line3 {
    stroke-dasharray: 90 207;
    stroke-dashoffset: -134;
    stroke-width: 6;
  }

  .mobile-nav-fade-enter-from,
  .mobile-nav-fade-leave-to {
    opacity: 0;
  }

  .mobile-nav-fade-enter-active,
  .mobile-nav-fade-leave-active {
    transition: opacity .5s ease;
  }

</style>